// extracted by mini-css-extract-plugin
export var copyRight = "e_bm_dc";
export var footerContainer = "e_bm_c8";
export var header = "e_bm_p";
export var link = "e_bm_db";
export var linkContainer = "e_bm_cl";
export var logoContainer = "e_bm_c9";